export const resetCartListItem = (element: HTMLElement) => {
  element.style.borderColor = ''
}
